import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  public theme = {
    current: undefined,
    format: undefined
  };

  public content;

  public brandMap = {
    REN: 'renault',
    NIS: 'nissan',
    RCI: 'rci',
    DAC: 'dacia'
  };

  constructor(@Inject(DOCUMENT) private document: Document) { }

  setThemeByBrandCode(brand, format) {
    this.theme.current = this.brandMap[brand];
    this.theme.format = format;
    this.loadStyle();
  }

  themeUrl() {
    if (!this.theme.current) {
      return;
    }
    // return 'themes/' + theme.current + '/theme-' + theme.format + '.css';
    return 'assets/css/' + this.theme.current +'.css';
    // return 'assets/css/' + this.theme.current + '/main.css';
  }

  // getContent() {
  //   $http.get('themes/' + this.theme.current + '/content.json')
  // }

  loadStyle() {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = this.themeUrl();
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.type = 'text/css';
      // style.href = `${styleName}`;
      style.href = this.themeUrl();

      head.appendChild(style);
    }
  }
}
